import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PackagesPage = lazy(() => import('../pages/packages/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfService = lazy(() => import('../pages/terms-of-service/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Service Detail Pages
const SocialMedia = lazy(() => import('../pages/service-detail/social-media/page'));
const DigitalAds = lazy(() => import('../pages/service-detail/digital-ads/page'));
const WebDesign = lazy(() => import('../pages/service-detail/web-design/page'));
const CRMAutomation = lazy(() => import('../pages/service-detail/crm-automation/page'));
const BrandIdentity = lazy(() => import('../pages/service-detail/brand-identity/page'));
const VideoProduction = lazy(() => import('../pages/service-detail/video-production/page'));

// Blog Detail Pages
const SocialMediaBlog = lazy(() => import('../pages/blog-detail/social-media/page'));
const DigitalAdsBlog = lazy(() => import('../pages/blog-detail/digital-ads/page'));
const CRMSystemBlog = lazy(() => import('../pages/blog-detail/crm-system/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/hakkimizda',
    element: <AboutPage />,
  },
  {
    path: '/hizmetler',
    element: <ServicesPage />,
  },
  {
    path: '/hizmetler/sosyal-medya',
    element: <SocialMedia />,
  },
  {
    path: '/hizmetler/dijital-reklamcilik',
    element: <DigitalAds />,
  },
  {
    path: '/hizmetler/web-tasarim',
    element: <WebDesign />,
  },
  {
    path: '/hizmetler/crm-otomasyon',
    element: <CRMAutomation />,
  },
  {
    path: '/hizmetler/marka-kimligi',
    element: <BrandIdentity />,
  },
  {
    path: '/hizmetler/video-produksiyon',
    element: <VideoProduction />,
  },
  {
    path: '/paketler',
    element: <PackagesPage />,
  },
  {
    path: '/sigorta-dijital-akademi',
    element: <BlogPage />,
  },
  {
    path: '/akademi/sosyal-medyada-sigorta-acentesi-nasil-buyur',
    element: <SocialMediaBlog />,
  },
  {
    path: '/akademi/dijital-reklamcilikta-basari-icin-5-altin-kural',
    element: <DigitalAdsBlog />,
  },
  {
    path: '/akademi/crm-sistemi-neden-her-acentenin-olmali',
    element: <CRMSystemBlog />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '/teklif-al',
    element: <QuotePage />,
  },
  {
    path: '/gizlilik-politikasi',
    element: <PrivacyPolicy />,
  },
  {
    path: '/kullanim-kosullari',
    element: <TermsOfService />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
